import React from "react";
import { useTranslation } from "react-i18next";
import { StyledTextInput } from "@aureskonnect/react-ui";
import classnames from "classnames";
import FormField from "../FormField";

interface Props {
    displayNameValue: string;
    selectName: boolean;
    isConsult: boolean;
    isEditMode: boolean;
    informationMode: string;
    isAdvancedDisabled: boolean;
    onChange: (e: any) => void;
    onAdvancedClick: () => void;
}

const DisplayNameField = React.memo(
    ({
        displayNameValue,
        selectName,
        isConsult,
        isEditMode,
        isAdvancedDisabled,
        onChange,
        onAdvancedClick,
    }: Props) => {
        const { t } = useTranslation();

        return (
            <FormField
                label={t("Display name")}
                required
                error={selectName}
                errorMessage={t("Please enter a display name")}
                headerRight={
                    <span
                        role="button"
                        tabIndex={0}
                        style={{
                            color: "blue",
                            cursor: "pointer",
                            textDecoration: "underline",
                            font: "normal normal 600 16px/21px Segoe UI",
                            marginTop: "15px",
                            border: "transparent",
                            backgroundColor: "transparent",
                        }}
                        onClick={onAdvancedClick}
                        className={classnames("cmn_btn_advencedDisplayName", {
                            "not-allowed-icon__clz": isAdvancedDisabled,
                        })}
                    >
                        {t("Advanced")}
                    </span>
                }
            >
                <StyledTextInput
                    className={classnames(
                        `${
                            isConsult ? "pe-none__clz" : ""
                        } mdi_inp_FRdisplayName`,
                        { input__clz: selectName }
                    )}
                    autocomplete="off"
                    name="designation"
                    onChange={onChange}
                    value={displayNameValue}
                    placeholder={t("Write")}
                    type="text"
                    autoFocus={isEditMode && !isConsult}
                />
            </FormField>
        );
    }
);

DisplayNameField.displayName = "DisplayNameField";
export default DisplayNameField;
